module.exports = __webpack_public_path__ + "static/cube13-5899dbcee8852514831d4058bc68a79b.svg";